import { render, staticRenderFns } from "./ProductAddBulkIframe.vue?vue&type=template&id=dd50e568&"
import script from "./ProductAddBulkIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductAddBulkIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports